export default "__VITE_ASSET__C3JAUS2Y__"